export default function CustomersList() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold">Customers</h1>
      <p className="text-muted-foreground mt-2">Coming soon.</p>
    </div>
  );
}
